import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sounds",
  "use": "icon-sounds-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"soundsIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" id=\"icon-sounds\"> <title id=\"icon-sounds_soundsIconTitle\">Sounds</title> <path d=\"M12 7L12 17\" /> <path d=\"M15 10L15 14\" /> <path d=\"M18 8L18 16\" /> <path d=\"M21 13L21 11\" /> <path d=\"M9 4L9 20\" /> <path d=\"M6 9L6 15\" /> <path d=\"M3 13L3 11\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol